export const TRACKING_MAP = {
  // City / Search
  city_search_limit:            { event: "city_search_limit_click",            trigger: "city_search_limit" },
  city_detail_limit:            { event: "city_detail_limit_click",            trigger: "city_detail_limit" },
  city_load_more_limit:         { event: "city_load_more_limit_click",         trigger: "city_load_more_limit" },
  city_comparison:              { event: "city_comparison_upgrade_limit_click", trigger: "city_comparison_limit" },
  city_comparison_detail_limit: { event: "city_comparison_detail_limit_click", trigger: "city_comparison_detail_limit" },
  save_city:                    { event: "save_city_limit_click",              trigger: "save_city_limit" },
  search_detail_utilities:      { event: "search_detail_utilities_limit_click", trigger: "search_detail_utilities_limit" },

  // Comparison
  comparison_limit:             { event: "comparison_upgrade_limit_click",     trigger: "comparison_limit" },
  nursing_role_limit:           { event: "nursing_role_limit_click",           trigger: "nursing_role_limit" },
  hospital_detail_limit:        { event: "hospital_detail_limit_click",        trigger: "hospital_detail_limit" },

  // Salary / Paycheck / Tax
  salary_page:                  { event: "salary_calculator_limit_click",      trigger: "salary_calculator_limit" },
  salary:                       { event: "median_salary_upgrade_limit_click",  trigger: "median_salary_limit" },
  housing:                      { event: "housing_upgrade_limit_click",        trigger: "housing_cost_limit" },
  paycheck_calculator_limit:    { event: "paycheck_calculator_limit_click",    trigger: "paycheck_calculator_limit" },
  paycheck_scenario_limit:      { event: "paycheck_scenario_limit_click",      trigger: "paycheck_scenario_limit" },
  paycheck_scenario_limit_duplicate: { event: "paycheck_scenario_duplicate_limit_click", trigger: "paycheck_scenario_limit" },
  tax_page:                     { event: "tax_page_limit_click",               trigger: "tax_page_limit" },
  tax_page_free_limit:          { event: "tax_page_free_limit_click",          trigger: "tax_page_free_limit" },
  mortgage_scenario_limit:      { event: "mortgage_scenario_limit_click",      trigger: "mortgage_scenario_limit" },
  salaries_page_scroll:         { event: "salaries_page_scroll_click",         trigger: "salaries_page_scroll" },

  // Jobs
  job_view_limit:               { event: "job_view_limit_click",               trigger: "job_view_limit" },
  job_view_banner:              { event: "job_view_banner_click",              trigger: "job_view_banner" },
  job_detail_utilities:         { event: "job_detail_utilities_limit_click",   trigger: "job_detail_utilities_limit" },
  save_job:                     { event: "save_job_limit_click",               trigger: "save_job_limit" },
  jobs_page_scroll:             { event: "jobs_page_scroll_click",             trigger: "jobs_page_scroll" },

  // Community
  comment_limit:                { event: "comment_upgrade_limit_click",        trigger: "comment_limit" },
  save_limit:                   { event: "save_post_upgrade_limit_click",      trigger: "save_limit" },
  post_limit:                   { event: "post_limit_click",                   trigger: "post_limit" },
  repost_limit:                 { event: "repost_limit_click",                 trigger: "repost_limit" },
  follow_limit:                 { event: "follow_limit_click",                 trigger: "follow_limit" },

  // Messaging
  messaging_notification_click: { event: "messaging_upgrade_click",            trigger: "messaging_limit" },

  // Other
  export_pdf:                   { event: "export_pdf_limit_click",             trigger: "export_pdf_limit" },
};

export const getTrackingData = (source) => {
  return (
    TRACKING_MAP[source] || {
      event: "upgrade_click",
      trigger: "unknown",
    }
  );
};
